
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import IconAdd from '@components/icons/icon-add.svg';

export type ButtonType = 'white' | 'blue' | 'green' | 'yellow';

@Component({
  name: 'TripDetailDataLine',
  components: {
    IconAdd
  }
})
export default class TripDetailDataLine extends Vue {
  @Prop({ required: true })
  private title: string;

  @Prop({ required: true })
  private label: string;

  @Prop({ default: '' })
  private labelPrefix: string;

  @Prop({ required: true })
  private id: string;

  @Prop()
  private value: string;

  @Prop({ default: '' })
  private valueBold: string;

  @Prop({ default: 'white' })
  private buttonType: ButtonType;

  @Prop({ default: false })
  private addButton: boolean;

  @Prop({ default: false })
  private editMode: boolean;

  @Prop({ default: false })
  private loading: boolean;

  @Prop()
  private addZoneRoute;

  get loadingText() {
    return this.buttonType === 'white' ? '' : 'Wird geladen...'
  }

  private emitEdit() {
    if (!this.loading) {
      this.$emit('toggleEditMode');
    }
  }
}
